import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import * as moment from 'moment';
import { IContentTileExpectedObj, IContentTileTextObj } from 'ui-ng-content-tile';
import { IDatasource, Query } from 'utility-ts-orm';
import { Schedule } from '../builders/schedule_builder';
import { IScheduleCourses, ScheduleSection, ScheduleTerm } from '../main';
import { ScheduleQuery } from './schedule_query';

interface ICalculateClassReturnObj {
  isActive: boolean;
  text: IContentTileTextObj;
}

export class SchedulePriorityFeedQuery implements IQuery {
  private _result: IContentTileExpectedObj;

  constructor(
    private ngScheduleQuery: ScheduleQuery,
    private ngScheduleSectionDatastore: IDatasource<ScheduleSection>,
    private ngScheduleTermsDatastore: IDatasource<ScheduleTerm>
  ) {
    Query.registerQuery(this, this.ngScheduleSectionDatastore, this.ngScheduleTermsDatastore);
  }

  _calculateClasses(courses: ScheduleSection[], now: any): ICalculateClassReturnObj {
    let nextClass: IScheduleCourses | undefined;
    let nextClassTime = moment().endOf('day');
    let numClassesToday = 0;
    _4.forEach(courses, (course: any) => {
      _4.forEach(course._sectionTime, (sectionTime: any) => {
        // Now +1 because moment is 0 index, server is not
        const endTime = moment(sectionTime.to_tm as string, 'HH:mm:ss');
        if (sectionTime.day_of_week === now.day() + 1 && endTime.isAfter(now)) {
          if (nextClassTime.isAfter(endTime)) {
            nextClassTime = moment(sectionTime.from_tm as string, 'HH:mm:ss');
            nextClass = course._course;
          }
          numClassesToday++;
        }
      });
    });
    if (numClassesToday === 0 || !nextClass) {
      return { isActive: false, text: { title: '', subTitle: '' } };
    }
    const classWord = numClassesToday === 1 ? 'class' : 'classes';
    return {
      isActive: true,
      text: {
        title: `${numClassesToday} ${classWord} today`,
        subTitle: `Next class: ${nextClass.cd} at ${nextClassTime.format('h:mma')}`
      }
    };
  }

  run(): this {
    const now = moment();
    const currentTerm = _4.first(
      this.ngScheduleTermsDatastore.query((term: ScheduleTerm) => term.term_end_dt > now && term.term_start_dt <= now)
    );

    const courses = _4.filter(
      this.ngScheduleSectionDatastore.query(
        (section: ScheduleSection) => section.class_end_dt > now && section.class_start_dt <= now
      ),
      (course: any) => this.ngScheduleQuery.isRegisteredCourse(course)
    );

    const { isActive, text } = this._calculateClasses(courses, now);
    this._result = {
      icon: { type: 'book_with_watch', theme: 'purple' },
      action: { state: 'my.courseSchedule.term', params: { termId: currentTerm ? currentTerm.id : '' } },
      isOverdue: false,
      text,
      isActive
    };
    return this;
  }

  get result() {
    return this._result;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/queries/schedule_priority_feed_query.ts